import classNames from 'classnames/bind';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  dataSelectBoxHeaderWings,
  optionsOrderPizza,
  optionsWings,
  toppingPizza,
  toppingPizzaTouch,
} from '~/utils/constants/mockData';
import { NameSelectBoxHeaderWingsEnum } from '~/utils/enum';
import styles from './WingsPage.module.scss';
import { orderActions } from '~/sagas/order/slice';
import { ButtonFoodOrder, ButtonFoodOrderTouch, SelectBox } from '~/components/specific';
import { IItemSelected } from '~/utils/interface/common';

const cx = classNames.bind(styles);

const PizzaPage = () => {
  const dispatch = useDispatch();
  const isTouchScreen = JSON.parse(localStorage.getItem('isTouchScreen') ?? 'false');

  const handleChangeWings = (itemSelected: IItemSelected) => {
    // TODO handle logic
  };

  const handleChangeSides = (itemSelected: IItemSelected) => {
    // TODO handle logic
  };

  const handleChangeDresssing = (itemSelected: IItemSelected) => {
    // TODO handle logic
  };

  const handleChangePreference = (itemSelected: IItemSelected) => {
    // TODO handle logic
  };

  const handleChangeSelectBox = (itemSelected: IItemSelected) => {
    if (itemSelected.id === -1) {
      return;
    }
    switch (itemSelected.nameSelectBox) {
      case NameSelectBoxHeaderWingsEnum.WINGS:
        handleChangeWings(itemSelected);
        break;
      case NameSelectBoxHeaderWingsEnum.SIDES:
        handleChangeSides(itemSelected);
        break;
      case NameSelectBoxHeaderWingsEnum.DRESSSING:
        handleChangeDresssing(itemSelected);
        break;
      case NameSelectBoxHeaderWingsEnum.PREFERENCE:
        handleChangePreference(itemSelected);
        break;
    }
  };

  return (
    <div id='wingsPage' className={cx('page-container')}>
      <div className={cx('page-head-wrap')}>
        {dataSelectBoxHeaderWings.map((item) => {
          const itemDefault = item.data.find((x) => x.id === item.defaultValue);
          return (
            <SelectBox
              key={item.name}
              name={item.name}
              data={item.data}
              defaultValue={itemDefault}
              onChange={handleChangeSelectBox}
            />
          );
        })}
      </div>

      <div className={cx('page-divide-line')} />

      {isTouchScreen ? (
        <div className={cx('page-body-wrap')}>
          {optionsOrderPizza.map((item) => (
            <ButtonFoodOrderTouch toppingItem={item} isActive={false} data={toppingPizzaTouch} key={item.id} />
          ))}
        </div>
      ) : (
        <div className={cx('page-body-wrap')}>
          {optionsWings.map((item) => (
            <ButtonFoodOrder toppingItem={item} isActive={true} data={toppingPizza} key={item.id} />
          ))}
        </div>
      )}
    </div>
  );
};

export default PizzaPage;
